import { SERVICE_ENDPOINTS } from 'src/environments/environment';

const SERVICE_EP: string = SERVICE_ENDPOINTS.dataIngestion;

export const ApiEndpoints = {
  GET_TEST_RECORDS: SERVICE_EP + `/test_records`,
  GET_NOSIE_TR_LIST: SERVICE_EP + '/nosie_test_records/list',
  SOFT_DELETE_UNUSED_TILS: SERVICE_EP + '/nosie_test_records/soft_delete_tils',
};
